import "./App.css";
import "@mantine/core/styles.css";
import {
  AppShell,
  Box,
  Burger,
  Center,
  Collapse,
  Divider,
  Drawer,
  Group,
  HoverCard,
  ScrollArea,
  UnstyledButton,
  rem,
  Text,
  ThemeIcon,
  Anchor,
  SimpleGrid,
  Menu
} from "@mantine/core";
import { useEffect, useState } from 'react';
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "./i18n";
import Logo from "./components/Logo/Logo";
import { BUNDLE_ENABLED } from "./config/features";
import { useDisclosure } from "@mantine/hooks";
import { Link, scroller } from 'react-scroll';
import { LanguagePicker } from "./components/LanguagePicker/LanguagePicker";
import {
  IconChevronDown,
} from "@tabler/icons-react";
import classes from "./App.module.css";
import { LanguagePickerMobile } from "./components/LanguagePickerMobile/LanguagePickerMobile";
import BodyContent from "./components/BodyContent/BodyContent";
import { SubscriptionPage } from "./components/Subscription/SubscriptionPage";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import ProfileContent from "./components/ProfileContent/ProfileContent";
import LoginButton from "./components/LoginButton/LoginButton";
import { FooterLinks } from "./components/FooterLinks/FooterLinks";
import { LanguageProvider } from './LanguageContext';
import { useSession } from "./auth/SessionContext";
import { useReferral } from "./scripts/ReferralContext";
import { DEBUG } from ".";
import tvlogo from "./media/accTV.png";
import acadlogo from "./media/acc-Academy.png";
import irdlogo from "./media/iRdrive-logo.png";
import lmudlogo from "./media/lmudrive-logo.png";
import drivelogo from "./media/drive-logo.png";
export function getParamValue(searchParam: string, iterator: IterableIterator<string>): string {
  const arrayFromIterator = Array.from(iterator);
  return arrayFromIterator[arrayFromIterator.indexOf(searchParam)];
}
const scrollToAnchor = (id: string) => {
  scroller.scrollTo(id, {
    duration: 500,
    delay: 0,
    offset: -64, // Offset in Pixel, um den Header zu berücksichtigen
  });
};
const apps = [
  { name: "ACC TV", logo: tvlogo, url: "https://acctv.de" },
  { name: "ACC DRIVE", logo: drivelogo, url: "https://accdrive.com" },
  { name: "ACC ACADEMY", logo: acadlogo, url: "https://academy.accsolutions.de/" },
  { name: "iR DRIVE", logo: irdlogo, url: "https://irdrive.accsolutions.de/" }
];
function App() {
  const { sessionData, loadSessionDataAsync } = useSession();
  const { getUrlWithRef } = useReferral();
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorId, setAnchorId] = useState<string | null>(null);
  const { t } = useTranslation();
  const redirectToHome = (id: string) => {
    setAnchorId(id);
    navigate("/");
  };
  useEffect(() => {
    loadSessionDataAsync();
  }, []);

  useEffect(() => {
    if (location.pathname === "/" && anchorId) {
      scrollToAnchor(anchorId);
      setAnchorId(null);
    }
  }, [location, anchorId]);

  const [opened] = useDisclosure();
  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] =
    useDisclosure(false);
    
  const [linksOpened, { toggle: toggleLinks }] = useDisclosure(false);
  
  return (
    <LanguageProvider>
      <div className="App">
        <AppShell
          header={{ height: 60 }}
          navbar={{
            width: "100%",
            breakpoint: "sm",
            collapsed: { desktop: true, mobile: !opened },
          }}>
          <AppShell.Header className={classes.headerOnTop} bg='black' style={{
            borderBottom: "1px solid #000", // 👈 deine Border hier
          }}>
            <Group h="100%" px="md" justify="space-between" style={{ display: 'flex', alignItems: 'center' }}>
              <Group gap={50} style={{ flex: 1 }}>
                <Text size="xl">
                  SimRacing SOLUTIONS
                </Text>
                <Group gap={10} style={{ flex: 1 }} visibleFrom="sm">
                </Group>
              </Group>
              <Group gap={10} style={{ flex: 1, justifyContent: 'center' }} visibleFrom="sm">
                {/*<UnstyledButton onClick={() => { redirectToHome("community"); }}>
                  <UnstyledButton>{t("menu.community")}</UnstyledButton>
                </UnstyledButton>*/}
              </Group>
              <Group style={{ flex: 1, justifyContent: 'flex-end' }} visibleFrom="sm">
                {BUNDLE_ENABLED && (
                  <UnstyledButton onClick={() => navigate("/subscribe")} className={classes.link}>
                    {t("menu.subscribe")}
                  </UnstyledButton>
                )}
                <LanguagePicker/>
                <LoginButton />
              </Group>
              <Burger
                opened={drawerOpened}
                onClick={toggleDrawer}
                hiddenFrom="sm"
              />
            </Group>
          </AppShell.Header>

          <Drawer
            bg='black'
            opened={drawerOpened}
            onClose={closeDrawer}
            size="100%"
            padding="md"
            title={
                <Text size="xl">
                  ACC SOLUTIONS
                </Text>}
            hiddenFrom="sm"
            zIndex={1000000}>
            <ScrollArea h={`calc(100vh - ${rem(80)})`} mx="-md">
              <Divider my="sm" />
              <Link to={"home"} onClick={() => { closeDrawer(); redirectToHome("home");}}>
                <Text className={classes.link}>{t("menu.home")}</Text>
              </Link>
              <UnstyledButton className={classes.link} onClick={toggleLinks}>
                <Center inline>
                  <Box component="span" mr={5}>
                    {t("menu.features")}
                    <IconChevronDown
                    style={{ width: rem(16), height: rem(16) }}
                    color={"#99180D"}
                  />
                  </Box>
                  
                </Center>
              </UnstyledButton>
              {BUNDLE_ENABLED && (
                <UnstyledButton className={classes.link} onClick={() => { closeDrawer(); navigate("/subscribe"); }}>
                  <Text>{t("menu.subscribe")}</Text>
                </UnstyledButton>
              )}
              <Divider my="sm" />
              <LoginButton />
              <LanguagePickerMobile />
            </ScrollArea>
          </Drawer>

          <AppShell.Main>
            <I18nextProvider i18n={i18n}>
              <Routes>
                <Route path="*" element={<BodyContent logged_in={false} />} />
                <Route path="/account" element={<ProfileContent />} />
                {BUNDLE_ENABLED && <Route path="/subscribe" element={<SubscriptionPage />} />}
              </Routes>
              <FooterLinks />
            </I18nextProvider>
          </AppShell.Main>
        </AppShell>
      </div>
    </LanguageProvider>
  );
}

export default App;
